import { h } from 'preact'
import { GroupItem, Item } from './types'

const GroupedListItem = ({ item } : { item : Item }) =>
  <div class='list-item' data-value={item.value} onClick={item.onClick}>{item.title}</div>

const GroupedList = ({ items } : { items: GroupItem[]}) =>
  <div class='list'>
    {items.map(item => <div>
      <div className='list-item list-item-group-name'>{item.groupName}</div>
      {item.items.map(item => <GroupedListItem item={item} />)}
    </div>)}
  </div>

export default GroupedList
